<!--
  - Copyright (c) 2022. Haodong JU
  -->

<template>
  <div
    class="text-body-2"
  >
    <div
      class="py-1"
    >
      <template v-if="inEdit">
        <div class="">
          <div class="text-body-2 pl-8 mb-2">
            {{ $t('option_name') }}
          </div>
          <div class="d-flex align-center">
            <v-icon
              class="mr-4"
              @click="$emit('edit-finished')"
            >
              mdi-unfold-less-horizontal
            </v-icon>
            <v-text-field
              v-model="agName"
              append-icon="mdi-text-short"
              dense
              hide-details
              outlined
            />
            <div style="width: 60px">
              <v-btn
                class="ml-1"
                icon
                @click="$emit('remove-ag',ag.id)"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </div>
          </div>
        </div>


        <attribute-sort-fragment
          :attribute-group="ag"
          :dish-id="currentDishId"
          :initial-list="ag.attributes"
          :selected-a-id-list="selectedAIdList"
          :title-name="titleName"
          item-sort="value"
          @save="editFinished"
          @click-checkbox="passEvent"
        />
      </template>
      <template v-else>
        <div
          class="d-flex align-start py-4"
          @click="$emit('edit')"
        >
          <v-icon
            class="mr-4 mt-1"
            @click.stop="$emit('edit')"
          >
            mdi-dots-vertical
          </v-icon>
          <div>
            <div
              class="d-flex align-center"
            >
              <div class="text-body-1 font-weight-bold text-capitalize">
                {{ ag.name }}
              </div>
            </div>
            <div class="d-flex mt-4 flex-wrap">
              <div
                v-for="a in selected"
                :key="a.id"
              >
                <v-chip
                  class="pa-2 mb-2 mr-2"
                  style="height: 24px"
                >
                  {{ a.name }}
                </v-chip>
              </div>
            </div>
          </div>
          <v-spacer/>
          <v-btn
            class="mr-7"
            outlined
            small
            @click.stop="$emit('edit')"
          >
            <v-icon left>
              mdi-pencil-box
            </v-icon>
            {{ $t('edit') }}
          </v-btn>
        </div>
      </template>
    </div>
    <v-divider class="mb-4"/>
  </div>
</template>

<script>
  import AttributeSortFragment from '@/views/AadenPages/dishes/dish/detail/fragments/widget/AttributeSortFragment'

  export default {
    name: 'AttributeCard',
    components: {
      AttributeSortFragment,
    },
    props: {
      titleName: {},
      ag: {},
      selectedAIdList: {},
      inEdit: {},
      currentDishId: {},
    },
    data () {
      return {
        agName: '',
      }
    },
    computed: {
      selected () {
        return this.ag?.attributes?.filter(it => this.selectedAIdList.includes(it.id.toString())) ?? []
      },
    },
    watch: {
      ag: {
        immediate: true,
        deep: true,
        handler (val) {
          this.agName = val.name
        },
      },
    },

    methods: {
      async editFinished () {
        this.$emit('edit-finished')
      },

      passEvent (aId, agId) {
        this.$emit('click-checkbox', aId, agId)
      },
    },
  }
</script>

<style scoped>

</style>
